import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
// 引入你本地的 Wisdomlogo.png 图标
import logo from '../images/Wisdomlogo.png';

// 顶部蓝色导航栏容器
const StyledHeader = styled.header`
  width: 100%;
  background-color: #0099ff;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
  }
`;

// Logo 图片容器（替换原来的文字）
const Logo = styled.div`
  img {
    height: 48px;
    width: auto;
    display: block;
  }

  @media (max-width: 768px) {
    img {
      height: 40px;
    }
  }
`;

// 导航链接容器
const NavLinks = styled.nav`
  display: flex;
  gap: 2.5rem;
  align-items: center;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem 1.2rem;
    width: 100%;
  }
`;

// 导航链接样式
const NavLink = styled(Link)`
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

// 语言选择下拉框
const LanguageSelect = styled.select`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333333;
  font-size: 1rem;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 0.4rem 0.6rem;
    font-size: 0.9rem;
  }
`;

const Header = () => {
  return (
    <StyledHeader>
      {/* 用 img 标签加载 logo.png，替换原来的 Wisdom 文字 */}
      <Logo>
        <Link to="/">
          <img src={logo} alt="Wisdom Logo" />
        </Link>
      </Logo>
      <NavLinks>
        <NavLink to="/">Home</NavLink>
        <NavLink to="/about">About us</NavLink>
        <NavLink to="/news">News</NavLink>
        <NavLink to="/products">Products</NavLink>
        <NavLink to="/lazada">Lazada</NavLink>
        <NavLink to="/contact">Contact us</NavLink>
        <LanguageSelect>
          <option value="en">English</option>
          <option value="es">Español</option>
        </LanguageSelect>
      </NavLinks>
    </StyledHeader>
  );
};

export default Header;